import { DirectionalServiceCompanyBase } from './base/directional-service-company-base';

export class DirectionalServiceCompany extends DirectionalServiceCompanyBase { }